import React, { useEffect } from 'react';
import './AboutMe.css'
import VanillaTilt from 'vanilla-tilt';
export default function AboutMe() {
  useEffect(() => {
    const cards = document.querySelectorAll('.card');
    cards.forEach((card) => {
      VanillaTilt.init(card, {
        max: 15,
        speed: 4,
        glare: true,
        'max-glare': 0.3,
      });
    });
  }, []);

  return (
    <div className="about-content">
      <div className='cont'>
        <h2 className='heading'>About <span>Me</span></h2>
        <p>So, about me! I'm an aspiring B.Tech. Computer Science student specializing in Artificial Intelligence and Data Science. My journey has been all about creating impactful software and conquering projects in detection, prediction, and classification. These experiences have bestowed me with a strong grasp of practical applications in these cutting-edge technologies. As I journey forward, my goal is to not only excel in the technical aspects but also to collaborate and communicate effectively, understanding that the best solutions are often born from collective efforts. If you're looking for a dedicated and forward-thinking team player who is ready to make a difference, I'm excited to connect and explore the endless possibilities together.</p>
        <a href={require("../../../images/Ayush Kumawat's Resume.pdf")} className="btn" download="Ayush Kumawat's.pdf"><i className="fa-solid fa-file-export"></i>Resume</a>
    </div>
    <div className='card'>
          <img src={require('../../../images/favicon.jpg')}  alt=''></img>
          <h1>Ayush Kumawat</h1>
          <h2>Data Analyst</h2>
          <h3>B.Tech (Hons.) Computer Science Engineer</h3>
          <h4>Specilization in Artifical Intelligence and Data Science</h4>
          <p>+91 - 9098984098 | ayu.kumawat2002@gmail.com</p>
      </div>
    </div>
  )
}